import React from 'react';
import Slider from 'react-slick';
import { settings } from '../JSSettings/carousel-setting';
import Aos from 'aos';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function Hero({ setOpenModal, setFrom }) {
    Aos.init({
        once: true,
        duration: 2000
    })
    const oncontactUsClick = () => {
        setFrom('Contact us today!')
        setOpenModal(true)
    }
    return (
        <section className="home-hero-a" id="home">
            {/* start Hero Section  */}
            <div className="container pb30">
                <div className="row">
                    <div className="col-lg-6 vcenter">
                        <div className="hero-content-a">
                            <h1 className="h1 mb30" data-aos="fade-in" data-aos-delay="200" ><span className="ree-text rt60">Providing</span> Solutions for Mobile App Design & Development Needs</h1>
                            <p data-aos="fade-in" data-aos-delay="500">From custom apps to ready-made solutions, we bring your vision to life in an efficient & cost effective way! Our highly qualified and experienced team has a proven track record to ensure top-quality results for our clients. <span className='ree-card-content-link' style={{ cursor: "pointer", fontWeight: "700", color: "#FF5B2E" }} onClick={oncontactUsClick}>Contact us today!</span></p>
                            {/* <a href="get-quote.html" className="ree-btn  ree-btn-grdt1 mt40 mw-80" data-aos="fade-in" data-aos-delay="800" >Let's Talk <i className="fas fa-arrow-right fa-btn"></i></a> */}
                        </div>
                    </div>
                    <div className="col-lg-6 vcenter">
                        <div className="sol-image d-flex justify-content-center align-items-center m-mt30">
                            <img src="images/marketplace.webp" alt="web development" className="img-hero-section" data-aos="fade-in" data-aos-delay="400" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="container hero-brand-block">
                <div className="row d-flex justify-content-center">
                    <div className="col-lg-10">
                        <div className="hero-brands w-90 mt30">
                            <Slider {...settings} >
                                <div className="brand-logo"><img src="images/brand-logo/iso.webp" alt="logo" className='img-fluid' /> </div>
                                <div className="brand-logo"><img src="images/brand-logo/gdpr.webp" alt="logo" className='img-fluid' /> </div>
                                <div className="brand-logo"><img src="images/brand-logo/google_top_rated.webp" alt="logo" className='img-fluid clutch-logo' /> </div>
                                <div className="brand-logo"><img src="images/brand-logo/top_app_devlopment.webp" alt="logo" className='img-fluid' /> </div>
                                <div className="brand-logo"><img src="images/brand-logo/clutch.webp" alt="logo" className='img-fluid clutch-logo' /> </div>
                                <div className="brand-logo"><img src="images/brand-logo/cyber_essencial.webp" alt="logo" className='img-fluid' /> </div>
                                {/* <div className="brand-logo"><img src="images/brand-logo/customer-logo-6.png" alt="logo" /> </div>
                                <div className="brand-logo"><img src="images/brand-logo/customer-logo-7.png" alt="logo" /> </div> */}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--hero Section End--> */}
        </section>
    )
}

export default Hero